// extracted by mini-css-extract-plugin
export default {"error":"FormError_error__zL5vN"};